import { ErrorMessage } from 'formik';
import { get, isObject, startCase, toLower } from "lodash";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from 'react-number-format';
import { Checkbox, Dropdown, Form, Input, Label, Search } from 'semantic-ui-react';




export function getValueFromEvent(e) {
  const { target } = e;
  let newValues;
  if (target) {
    const value = (target.type === "checkbox") ? target.checked : target.value;
    newValues = { [target.name]: value }
  }
  else if (isObject(e)) { newValues = e; }
  return newValues;
}

export const FormikIntegerComponent = ({
  isLabel, label, saveOnBlur, decimal, compute, isTxn, path, placeholder, isMandatory, focus, width, fieldName, onFocus, classField, maxlength, fieldtype, readonly, tabindex,
  computeValue, fromField, otherList, 
  field, // { name, value, onChange, onBlur }
  index,
  form: { touched, errors, values, handleSubmit, handleBlur, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field className={classField ? classField : null} style={{width:"100%"}}width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}{isMandatory ? <font color="red"> * </font> : null}</label>}
      <NumberFormat 
        thousandSeparator={false} 
        thousandsGroupStyle=""
        decimalScale = {0}
        placeholder={placeholder}
        name={field.name}
        value={field.value}
        maxLength={maxlength ? maxlength : 1000}
        onValueChange={(val) => setFieldValue(field.name, val.floatValue)}
        onChange={(e) => {
          if(computeValue){
            computeValue(values, index, setFieldValue, field.name, fieldName, fromField, otherList, e.target.value, fieldtype)
          }
          
        }}
        onBlur={(e, val) =>{
          // e.persist()
          // handleBlur(e)
          if (compute) compute(values, index, setFieldValue, field.name, fieldName)
        }}
        autoFocus={focus ? focus : false}
        style={{textAlign: 'right'}}
        readOnly = {readonly ? readonly : false}
        tabIndex = {tabindex ? tabindex : 0}
      />
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
    </Form.Field>
  );


export const FormikIntegerOnlyLeftComponent = ({
  isLabel, label, saveOnBlur, decimal, compute, isTxn, path, placeholder, isMandatory, focus, width, fieldName, onFocus, classField, maxlength, fieldtype, readonly, tabindex,
  computeValue, fromField, otherList, 
  field, // { name, value, onChange, onBlur }
  index,
  form: { touched, errors, values, handleSubmit, handleBlur, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field error={get(errors, field.name) && get(touched, field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label : startCase(toLower(field.name))}{isMandatory ? <font color="red"> * </font> : null}</label>}
      <NumberFormat 
        thousandSeparator={false} 
        thousandsGroupStyle=""
        decimalScale = {0}
        placeholder={placeholder}
        name={field.name}
        value={field.value}
        maxLength={maxlength ? maxlength : 1000}
        onValueChange={(val) => setFieldValue(field.name, val.floatValue)}
        onChange={(e) => {
          if(computeValue){
            computeValue(values, index, setFieldValue, field.name, fieldName, fromField, otherList, e.target.value, fieldtype)
          }
          
        }}
        onBlur={(e, val) =>{
          // e.persist()
          // handleBlur(e)
          if (compute) compute(values, index, setFieldValue, field.name, fieldName)
        }}
        autoFocus={focus ? focus : false}
        style={{textAlign: 'left'}}
        readOnly = {readonly ? readonly : false}
        tabIndex = {tabindex ? tabindex : 0}
      />
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
    </Form.Field>
  );
export const FormikInputComponent = ({
  validateInput, isLabel, label, isTxn, placeholder, className, focus, maxlength, callajax, readOnly, callUseState, listobj, isMandatory, setFieldValueM, boxwidth, getIndex, onChangeFunc,onBlurFunc,
  field, // { name, value, onChange, onBlur }
  index,
  form: { touched, errors, values, handleChange, setFieldValue, setFieldError, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  let manValue = setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined ? setFieldValueM : ""
  useEffect(() => {
    if (setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined && setFieldValueM !== "") {
      setFieldValue(field.name, manValue)
    } else if (setFieldValueM && setFieldValueM === "") {
      setFieldValue(field.name, '')
    }
  }, [manValue])
  return (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field error={get(errors, field.name) && get(touched, field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label : startCase(toLower(field.name))}{isMandatory ? <font color="red"> * </font> : null}</label>}
      <Input
        name={field.name}
        type="text"
        placeholder={placeholder}
        onChange={handleChange}
        value={field.value || ""}
        readOnly={readOnly ? readOnly : false}
        tabIndex={readOnly === true ? -1 : 0}
        autoFocus={focus ? focus : false}
        className={className ? className : ""}
        style={{ textAlign: "left", width: boxwidth ? boxwidth : '100%' }}
        onBlur={(e) => {
          if (callajax) { callajax(values, index, setFieldValue, callUseState, listobj, field.value, getIndex) }
          if (onChangeFunc) { onChangeFunc(values, field.value, setFieldValue) }
          if(onBlurFunc){
            onBlurFunc(e, values, index, setFieldValue, field.value, field.name, setFieldError)
          }
        }}
        {...props}
        maxLength={maxlength ? maxlength : ""}

      />
      {isTxn ? <ErrorMessage name={field.name} render={msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label>} /> : null}
    </Form.Field>
  )
};


export const FormikDateComponent = ({
  isLabel, label, placeholder,isAutoComplete, setDate,setFieldValueM,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue, dirty }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {

  const [dt, setDt] = useState(field.value ? moment(field.value).toDate() : null)
  const handleDateChange = (e) => {
    setDt(e)
    const dt = moment(e)
    handleChange(dt.format("DD-MM-YYYY"))
    setFieldValue(field.name, dt.format("YYYY-MM-DD"))
  }

  const handleCalendarClose = (e) => {
    if(setDate){
      setDate(moment(dt).format("YYYY-MM-DD"))
    }
  }
  let manValue = setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined ? setFieldValueM : ""
  useEffect(() => {
    if(setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined && setFieldValueM !== ""){
      setFieldValue(field.name, setFieldValueM)
      setDt(moment(setFieldValueM).toDate()) 
    }else if(setFieldValueM && setFieldValueM === ""){
      setFieldValue(field.name, '')
      setDt('') 
    }
  }, [manValue])

  return (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
      <DatePicker
        name={field.name}
        placeholderText={placeholder}
        dateFormat="dd-MM-yyyy"
        autocomplete="off"
        scrollableYearDropdown
        selected={field.value ? dt : null}
        onChange={handleDateChange}
        onCalendarClose={(e) => handleCalendarClose(e)}
      />
    </Form.Field>
  )};

  
export const FormikAmountComponent = ({
  isLabel, label, saveOnBlur, decimal, compute, isTxn, path,
  field, // { name, value, onChange, onBlur }
  index,
  form: { touched, errors, values, handleSubmit, handleBlur, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
      <NumberFormat 
        thousandSeparator={true} 
        thousandsGroupStyle="lakh"
        decimalScale = {(decimal) ? decimal : 2 }
        name={field.name}
        value={field.value}
        onValueChange={(val) => setFieldValue(field.name, val.floatValue)}
        onBlur={(e) =>{
          // e.persist()
          // handleBlur(e)
          if (compute) compute(values, index, setFieldValue)
        }}
      />
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
    </Form.Field>
  );


export const FormikCheckBoxComponent = ({
  userProps,label, className,setWsToggle, isChecked,setToggle,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
 // console.log(field,'================filed')
 
const onClicked=(checked)=>{
  // console.log(checked,'========checked')
  if(checked===true){
    if(setToggle){
      setToggle("yes")
    }
   
    setFieldValue(field.name, "y")
  }else{
    if(setToggle){
      setToggle('no')
    } 
    setFieldValue(field.name, "n")
    
  }
  
}

    return (
    <Form.Field error={get(errors,field.name) && get(touched,field.name)}>
      <Checkbox toggle
      name={field.name}
      defaultChecked={isChecked ? isChecked : false}
      label={label ? label : ""}
      className={className ? className :""}
      onClick={(e, { checked})=>onClicked(checked)}
    
    />
      {/* <label>{label? label :""}</label> */}
    </Form.Field>
)};  

export const FormikSelectComponent = ({
  userProps, isLabel, label, isTxn, isSelection,placeholder,isClearable,index,type,classNameGet,isMandatory,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {

const onChange = (value) => {
  setFieldValue(field.name, value)
  if (userProps.getValue){
    userProps.getValue(value, setFieldValue, values, type, index, field.name);
  }
}

return (
  // <Form.Field error={errors[field.name] && touched[field.name]}>
  <Form.Field error={get(errors,field.name) && get(touched,field.name)} className={classNameGet ? classNameGet : "goRelative"}>
    {errors[field.name] && touched[field.name] && !isTxn ?
      <label>{errors[field.name]}</label> :
      <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}{isMandatory ? <font color="red"> * </font> : null}</label>}
    <Dropdown
      search
      selection={isSelection ? true : false}
      id={field.id}
      name={field.name}
      placeholder={placeholder ? placeholder : "Select"}
      options={userProps.options}
      value={field.value}
      onChange={(e, { value }) => onChange(value)}
      clearable={isClearable ? isClearable : false}
      selectOnNavigation={false}
      />     
    {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
    </Form.Field>
)};  


export const FormikAsyncSelectComponent = ({
  userProps, isLabel, label, isTxn, isSelection,placeholder,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {

  const onChange = (value) => {
    console.log('onChange', value);
    setFieldValue(field.name, value)
    if (userProps.getValue)
      userProps.getValue(value);
  }


  const loadOptions = (searchQuery) => {
    console.log(searchQuery)
    userProps.getInputValue(searchQuery);
  }

  return (

    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
        {/* {console.log(field.value, userProps.options)} */}
        {/* {console.log(userProps.searchOptions)} */}
      <Dropdown
        search
        selection={isSelection ? true : false}
        // selectOnNavigation={true}
        id={field.id}
        name={field.name}
        placeholder={placeholder ? placeholder : userProps.placeHolder}
        options={userProps.searchOptions && userProps.searchOptions.length>0 ? userProps.searchOptions : userProps.options}
        value={field.value}
        onSearchChange={(e, { searchQuery }) => loadOptions(searchQuery)}
        onChange={(e, { value }) => onChange(value)}
        />
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
  )
};  

export const FormikPasswordComponent = ({
  validateInput, placeholder, width, isLabel, label, isTxn, focus,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) =>  (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
        <Input name={field.name}
          type="password"
          onChange={handleChange}
          value={field.value || ""}
          placeholder={placeholder}
          autoFocus={focus ? focus : false}
        />
        {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
);

export const FormikHiddenInputComponent = ({
  validateInput, isLabel, label, isTxn, placeholder, className, focus, maxlength, callajax, readOnly, callUseState, listobj, isMandatory, setFieldValueM, boxwidth, getIndex,
  field, // { name, value, onChange, onBlur }
  index,
  form: { touched, errors, values, handleChange, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  let manValue = setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined ? setFieldValueM : ""
  useEffect(() => {
    if (setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined && setFieldValueM !== "") {
      setFieldValue(field.name, manValue)
    } else if (setFieldValueM && setFieldValueM === "") {
      setFieldValue(field.name, '')
    }
  }, [manValue])
  return (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field error={get(errors, field.name) && get(touched, field.name)} style={{ display: 'none' }}>
      <Input
        name={field.name}
        type="hidden"
        placeholder={placeholder}
        onChange={handleChange}
        value={field.value || ""}
        readOnly={readOnly ? readOnly : false}
        autoFocus={focus ? focus : false}
        className={className ? className : ""}
        style={{ textAlign: "left", width: '0%', display: 'none' }}
        onBlur={(e) => {
          if (callajax) { callajax(values, index, setFieldValue, callUseState, listobj, field.value, getIndex) }
        }}
        defaultValue={field.value || ""}
        {...props}
        maxLength={maxlength ? maxlength : ""}

      />
    </Form.Field>
  )
};

export const FormikAsyncSearchComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  const { handleSearchChange, userProps, loading, className, tabindex, placeholder, focus, disabled, isLabel, isTxn, label, index, open, isMandatory } = props

  return (
    <Form.Field id={field.name + "GetId"} error={get(errors, field.name) && get(touched, field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label >{errors[field.name]}</label> :
        isLabel === true ? "" : <label >{isLabel ? null : label ? label : startCase(toLower(field.name))}
          {isMandatory ? <font color="red"> * </font> : null}
        </label>}

      <Search
        id={field.name}
        loading={loading}
        className={className}
        tabIndex={tabindex ? tabindex : 0}
        placeholder={placeholder}
        name={field.name}
        focus={focus}
        onSearchChange={(e, data) => {
          // Update the field value in Formik
          setFieldValue(field.name, data.value);
          // Call your custom handleSearchChange function
          handleSearchChange(e, data);
        }}
        disabled={disabled}
        results={userProps.options && userProps.options !== undefined && userProps.options !== null && userProps.options !== "" && userProps.options.length > 0 ? userProps.options : []}
        onResultSelect={(e, data) =>
          userProps.getInputValue(e, setFieldValue, field.name, data.result, values, index)
        }
        onBlur={(e, data) => {
          userProps.handleOnBlur(e, setFieldValue, field.name, data.result, values, index)
        }}
        onKeyUp={(e) => {
          userProps.handleKeyUp(e, setFieldValue, field.name, values, index)
        }}
        onFocus={(e, data) => {
          userProps.handleFocus(e, setFieldValue, field.name, values, index)
        }}
        onKeyDown={(e) => {
          userProps.handleKeyDown(e, setFieldValue, field.name, values, index)
        }}
        fluid
        key={index}
        // open={open}
        // showNoResults={userProps.options.length === 0 ? true : false}
        noResultsMessage={userProps.options.length === 0 ? "No results found" : null}
        size='small'
        selectFirstResult={false}
        value={field.value ? field.value : ""}
      />
      <ErrorMessage name={field.name} render={msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label>} />
    </Form.Field>
  )
};

